/**
 * Menü-címke → Material Symbols ikon a prototípus oldalmenüje szerint. A menüszolgáltatás Font Awesome
 * osztályai maradnak (más helyeken még használjuk), az új váz ebből a táblából dolgozik.
 */
export const SZ_MENU_ICONS: Record<string, string> = {
  Home: 'home',
  My_invoices: 'receipt_long',
  Invoice_reports: 'summarize',
  Claims: 'report',
  Remaining_orders: 'pending_actions',
  Offers: 'percent',
  Offers_documents: 'description',
  Posts: 'newspaper',
  NP_dashboard: 'bar_chart',
  Sales_reports: 'bar_chart',
  Commitment_documents: 'bar_chart',
  Partner_program_report: 'bar_chart',
  Product_certificate_documents: 'receipt',
  Partner_program: 'local_pharmacy',
  Substitutions: 'swap_horiz',
  Partner_contacts: 'contact_mail',
  Loyalty_pharmacy: 'stars',
  Loyalty_pharmacy_overview: 'dashboard',
  Loyalty_pharmacy_staff: 'group',
  Loyalty_pharmacy_campaigns: 'campaign',
  Loyalty_pharmacy_trainings: 'school',
  Loyalty_pharmacy_points: 'receipt_long',
  Loyalty_pharmacy_redemption: 'redeem',
  Partner_program_assets: 'campaign',
  Issue_reports: 'bug_report',
  Issue_reports_admin: 'bug_report',
  Company_details: 'apartment',
  Szirom_Pont: 'stars',
  Loyalty_staff: 'stars',
  Loyalty_members: 'group',
  Loyalty_pharmacies: 'local_pharmacy',
  Loyalty_campaigns: 'campaign',
  Loyalty_trainings: 'school',
  Loyalty_import: 'upload_file',
  Loyalty_reports: 'flag',
  Loyalty_vouchers: 'redeem',
  Loyalty_messages: 'chat',
  Loyalty_balances: 'account_balance_wallet',
  Loyalty_substitutes: 'medication',
  Loyalty_settings: 'tune',
  Administration: 'admin_panel_settings',
  Subscriptions: 'store',
  Internal_users: 'badge',
  Pharmacy_users: 'group',
  Pharmacist_users: 'medication',
  Email_templates: 'mail',
  Email_log: 'outgoing_mail',
  Anthroposophy_products: 'spa',
  Anthroposophy_subscriptions: 'local_pharmacy',
  AvailableSubstitution: 'swap_horiz',
  MySubstitution: 'event_available',
  Sanofi_webshop: 'shopping_cart',
  Help: 'help',
};

export function szMenuIcon(label: string): string {
  return SZ_MENU_ICONS[label] || 'circle';
}
